import React, { useState } from 'react';
import { TreeItem } from '@mui/x-tree-view/TreeItem';
import TreeCategory from './TreeCategory';
import TreeCategoryElement from './TreeCategoryElement';
import FormatListNumberedIcon from '@mui/icons-material/FormatListNumbered';
import EditIcon from '@mui/icons-material/Edit';
import QueueIcon from '@mui/icons-material/Queue';
import Repositions from './Repositions';
import ReactModal from '../../../../../components/ReactModal';
import ManageCategory from '../../../../../components/ManageCategory';

const TreeGroup = (props) => {
  const { category, expanded, setExpanded } = props;
  const [repositionsModalIsOpen, setRepositionsModalIsOpen] = useState(false);
  const [editCategoryModalIsOpen, setEditCategoryModalIsOpen] = useState(false);
  const [newCategoryModalIsOpen, setNewCategoryModalIsOpen] = useState(false);

  const handleRepositions = (e) => {
    e.stopPropagation();
    setRepositionsModalIsOpen(true);
  };

  const handleEditCategory = (e) => {
    e.stopPropagation();
    setEditCategoryModalIsOpen(true);
  };

  const handleAddSubCategory = (e) => {
    e.stopPropagation();
    setNewCategoryModalIsOpen(true);
  };

  const smallWindow = window.innerWidth < 500;

  return (
    <div style={{ position: 'relative', marginLeft: '-20px', marginRight: '10px' }}>
      <TreeItem
        key={category.id}
        nodeId={category.id}
        label={<TreeCategoryElement category={category} />}
        style={{ margin: '16px 0' }}
        onClick={() => {
          const newExpanded = { ...expanded };
          newExpanded[category.id] = !expanded[category.id];
          setExpanded(newExpanded);
        }}
      >
        {category.categories &&
          category.categories.map((category) => {
            return (
              <TreeCategory
                key={category.id}
                category={category}
                expanded={expanded}
                setExpanded={setExpanded}
                style={{ marginLeft: '0px', marginRight: '0px' }}
              />
            );
          })}
      </TreeItem>
      {expanded[category.id] && (
        <div
          style={{
            position: 'absolute',
            top: smallWindow ? -16 : 16,
            right: smallWindow ? -16 : 16,
          }}
        >
          <FormatListNumberedIcon
            className="s-24-i txt-info pl-16 pr-8"
            onClick={handleRepositions}
          />
          <EditIcon className="s-24-i txt-info pl-8 pr-8" onClick={handleEditCategory} />
          <QueueIcon className="s-24-i txt-info pl-8 pr-8" onClick={handleAddSubCategory} />
        </div>
      )}
      {repositionsModalIsOpen && (
        <ReactModal modalIsOpen={repositionsModalIsOpen} setIsOpen={setRepositionsModalIsOpen}>
          <Repositions
            reposition={{
              type: 'subcategories',
              filter: category.id,
            }}
            close={() => {
              setRepositionsModalIsOpen(false);
              const newExpanded = { ...expanded };
              newExpanded[category.id] = true;
              setExpanded(newExpanded);
            }}
          />
        </ReactModal>
      )}
      {editCategoryModalIsOpen && (
        <ReactModal modalIsOpen={editCategoryModalIsOpen} setIsOpen={setEditCategoryModalIsOpen}>
          <ManageCategory
            categoryId={category.id}
            close={() => setEditCategoryModalIsOpen(false)}
          />
          <div style={{ height: '200px' }} />
        </ReactModal>
      )}
      {newCategoryModalIsOpen && (
        <ReactModal modalIsOpen={newCategoryModalIsOpen} setIsOpen={setNewCategoryModalIsOpen}>
          <ManageCategory
            categoryId="new"
            nested={category.id}
            serviceId={category.service_id}
            close={() => setNewCategoryModalIsOpen(false)}
            restricted
          />
          <div style={{ height: '200px' }} />
        </ReactModal>
      )}
    </div>
  );
};

export default TreeGroup;
